import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronLeft, Home } from 'lucide-react';

/* Theme-aware breadcrumb: خانه / ... / جاری (clickable). */
export default function Breadcrumb({ items = [], style }) {
  if (!items.length) return null;
  return (
    <nav aria-label="مسیر" style={{ display: 'flex', alignItems: 'center', gap: 4, flexWrap: 'wrap', fontSize: '0.8rem', marginBottom: 14, ...style }}>
      <Link to="/" aria-label="خانه" style={{ display: 'inline-flex', alignItems: 'center', color: 'var(--muted-fg)', textDecoration: 'none' }}>
        <Home size={15} />
      </Link>
      {items.map((it, i) => {
        const last = i === items.length - 1;
        return (
          <span key={i} style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}>
            <ChevronLeft size={14} color="var(--muted-fg)" style={{ flexShrink: 0 }} />
            {last || !it.to ? (
              <span style={{ color: last ? 'var(--fg)' : 'var(--muted-fg)', fontWeight: last ? 700 : 400, maxWidth: 220, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', display: 'inline-block', verticalAlign: 'bottom' }}>{it.label}</span>
            ) : (
              <Link to={it.to} style={{ color: 'var(--muted-fg)', textDecoration: 'none', fontWeight: 600 }}>{it.label}</Link>
            )}
          </span>
        );
      })}
    </nav>
  );
}
